/**
 * Members-Only Content Teaser Analytics Tracking
 * Ticket #25556: Members-Only Content with Public Teaser Pages
 */

(function($) {
    'use strict';

    /**
     * jQuery throttle helper - must be defined before document.ready
     * Limits function execution rate
     */
    if (typeof $.throttle === 'undefined') {
        $.throttle = function(delay, fn) {
            let last = 0;
            return function(...args) {
                const now = Date.now();
                if (now - last >= delay) {
                    last = now;
                    fn.apply(this, args);
                }
            };
        };
    }

    /**
     * Store event to WordPress via AJAX
     *
     * @param {string} eventName - Event name matching PHP meta key map
     */
    function storeEvent(eventName) {
        // Check if analytics config is available
        if (typeof window.ieuAnalytics === 'undefined') {
            return;
        }

        $.ajax({
            url: window.ieuAnalytics.ajaxUrl,
            type: 'POST',
            data: {
                action: 'ieu_track_content_event',
                nonce: window.ieuAnalytics.nonce,
                event_name: eventName,
                post_id: window.ieuAnalytics.postId
            }
        });
    }

    /**
     * Track event to dataLayer and store locally
     *
     * @param {string} eventName - Event name for dataLayer
     * @param {object} eventData - Additional event data
     * @param {string} storeAs - Optional: event name for local storage (if different)
     */
    function trackEvent(eventName, eventData = {}, storeAs = null) {
        // Track to dataLayer if available (for GTM)
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: eventName,
                ...eventData
            });
        }

        // Store to WordPress post meta
        if (storeAs) {
            storeEvent(storeAs);
        }

        // Track to console in development
        if (window.location.hostname === 'localhost' || window.location.hostname.includes('.local') || window.location.hostname.includes('.test')) {
            console.log('[IEU Member Content] Event:', eventName, storeAs ? '(stored as: ' + storeAs + ')' : '', eventData);
        }
    }

    /**
     * Initialize tracking for teaser page
     */
    function initTeaserTracking() {
        const $teaserContainer = $('.ieu-member-teaser, .ieu-member-upsell');

        if ($teaserContainer.length === 0) {
            return;
        }

        const postId = $teaserContainer.data('teaser-post-id');
        const postTitle = $teaserContainer.find('.entry-title').text().trim();
        const pageType = $teaserContainer.hasClass('ieu-member-teaser') ? 'teaser' : 'upsell';

        // Track page view
        trackEvent('ieu_member_content_view', {
            content_type: pageType,
            post_id: postId,
            post_title: postTitle,
            page_location: window.location.href,
            page_path: window.location.pathname
        });

        // Track CTA clicks
        $('.ieu-teaser-cta-login, .ieu-upsell-cta-join, .ieu-teaser-cta-join').on('click', function(e) {
            const $this = $(this);
            const ctaType = $this.hasClass('ieu-teaser-cta-login') ? 'login' : 'join';
            const ctaLocation = $this.data('event') || 'unknown';
            const ctaUrl = $this.attr('href');

            // Map to storage event name
            const storeAs = ctaType === 'login' ? 'cta_login_click' : 'cta_join_click';

            trackEvent('ieu_member_content_cta_click', {
                content_type: pageType,
                cta_type: ctaType,
                cta_location: ctaLocation,
                cta_url: ctaUrl,
                post_id: postId,
                post_title: postTitle
            }, storeAs);
        });

        // Track scroll depth on teaser
        if ($teaserContainer.hasClass('ieu-member-teaser')) {
            let scrollDepthTracked = {
                '25': false,
                '50': false,
                '75': false,
                '90': false
            };

            $(window).on('scroll', $.throttle(500, function() {
                const scrollTop = $(window).scrollTop();
                const docHeight = $(document).height();
                const winHeight = $(window).height();
                const scrollPercent = Math.round((scrollTop / (docHeight - winHeight)) * 100);

                Object.keys(scrollDepthTracked).forEach(function(depth) {
                    const depthNum = parseInt(depth);
                    if (scrollPercent >= depthNum && !scrollDepthTracked[depth]) {
                        scrollDepthTracked[depth] = true;
                        // Only store 90% scroll depth to post meta
                        const storeAs = depthNum === 90 ? 'scroll_depth_90' : null;
                        trackEvent('ieu_member_content_scroll', {
                            scroll_depth: depthNum,
                            post_id: postId,
                            post_title: postTitle
                        }, storeAs);
                    }
                });
            }));
        }
    }

    // Initialize on document ready
    $(document).ready(function() {
        initTeaserTracking();
    });

})(jQuery);
